<template lang="html">
  <div id="reschedulingReceiverPage">
    <div class="help">
      <span class="help-icon" @click="helpCliked()">
        <i class="icon-question-sign" v-if="!help_cliked"></i>
        <i class="icon-circledelete" v-if="help_cliked"></i>
      </span>
      <div class="help_information" v-if="help_cliked">
        <h2 class="helpH2">振替依頼をされた場合</h2>
    		<ol class="helpOl">
    			<li>「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く</li>
    			<li>メール内のURLをクリック</li>
    			<li>画面の指示に従い、入力を進める</li>
    			<ol>
    				<li style="font-weight: bold; margin-top: 5px;">【承認する場合】</li>
    				<ol class="helpO2 ol-second-level">
    					<li>①振替候補日時からご都合の良い日時を選択</li>
    					<li>　（講師のみ振替後の授業の情報を指定）</li>
    					<li>②振替後の授業を予約する座席を選択</li>
    					<li>③入力項目を確認し、「振替を確定する」をクリック</li>
    					<li>　または、「戻って修正する」ボタンをクリック</li>
    					<li>④完了画面を確認し、「座席表トップへ」をクリック</li>
    				</ol><br>
    				<li style="font-weight: bold; margin-top: 5px;">【不承認する場合】</li>
    				<ol class="helpO2 ol-second-level">
    					<li>①「振替を不承認する」にチェックを入れる</li>
    					<li>　（講師のみ振替後の授業の情報を指定）</li>
    					<li>②他の振替候補日時を入力</li>
    					<li>③入力項目を確認し、「振替依頼を不承認する」をクリック</li>
    					<li>　または、「戻って修正する」ボタンをクリック</li>
    					<li>④完了画面を確認し、「座席表」をクリック</li>
    				</ol>
    			</ol>
    		</ol>
    		<div class="messagetext">
    			<span class="box-title">承認/不承認をしたあとは・・・</span>
    				承認・不承認の結果がメールで依頼者に届きます。<br>
    				承認した場合は、そのまま振替後の日時に教室にお越しください。<br>
    				不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。
    		</div>
      </div>
    </div>
    <router-view />
    <el-button
      class="btn"
      @click="$router.push('/table')"
    >
      座席予約表トップへ
    </el-button>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        help_cliked: false
      }
    },
    methods: {
      helpCliked () {
        if (!this.help_cliked) {
          this.help_cliked = true
        } else {
          this.help_cliked = false
        }
      }
    }
  }
</script>
<style lang="css" scoped>
  #reschedulingReceiverPage {
    text-align: center;
    font-family: 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','ヒラギノ角ゴシック',YuGothic,'Yu Gothic','メイリオ', Meiryo,'ＭＳ Ｐゴシック','MS PGothic', 'sans-serif';
    margin-bottom: 50px;
  }
  .header {
    background-color: #0065B3;
    color: white;
    text-align: center;
    font-size: 24px;
    margin: 10px auto;
    max-width: 500px;
  }
  .help {
    width: auto;
    float: right;
    position: fixed;
    z-index: 100;
    top: 60px;
    right: 10px;
  }
  .help-icon{
    color: #ffd500;
    font-size: 50px;
  }
  .help-icon :hover{
    color: #E69200;
  }
  .help_information{
    width: auto;
    float: right;
    position: fixed;
    z-index: 100;
    top: 115px;
    right: 50px;
    background-size: cover;
    background-color: rgba(255, 255, 255);
    border: solid 3px #6091d3;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingReceiverPage.vue?2cfe4cca